import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  container: {
    width: '100%',
    height: '100%',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: [theme.spacing(2), theme.spacing(4)],
  },
  blackBackground: {
    backgroundColor: theme.palette.colors.black,
    [theme.breakpoints.up('mobile')]: {
      backgroundColor: theme.palette.colors.white,
    },
  },
  header: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: [theme.spacing(2), 0],
  },
  buttonContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    paddingTop: theme.spacing(1),
  },
  button: {
    width: '100%',
    [theme.breakpoints.up('mobile')]: {
      marginTop: theme.spacing(2),
    },
  },
  videoContainer: {
    flexGrow: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  profileReviewContainer: {
    flexGrow: 1,
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    maxHeight: '80%',
    [theme.breakpoints.up('mobile')]: {
      width: 400,
      maxHeight: 400,
    },
  },
}));



// WEBPACK FOOTER //
// ./src/components/BuyerLoanOfficerSearchSurvey/components/LoanOfficerSelect/components/LoanOfficerProfileReviewPopup/useStyles.js